import axios from "axios";
import { getToken } from "./auth";
import { getStore } from "@/utils/store";
import i18n from "@/lang"; // Internationalization
import { Message } from "element-ui";

const cancelTokens = {};
let isOnly = false; //当上一个请求未完成时是否取消上一次请求

const getRequestKey = (config = {}) => {
  return config.url + "_" + config.method;
};

const addPending = (config) => {
  const requestKey = getRequestKey(config);
  if (cancelTokens[requestKey]) {
    cancelTokens[requestKey].cancel("cancel request");
  }
  const source = axios.CancelToken.source();
  cancelTokens[requestKey] = source;
  config.cancelToken = source.token;
};

const deletePending = (res) => {
  const requestKey = getRequestKey(res.config);
  if (cancelTokens[requestKey]) {
    delete cancelTokens[requestKey];
  }
};

const service = axios.create({
  timeout: 60000,
  retry: 3, // 请求次数,
  retryInterval: 1000, // 请求超时后，1s再次请求
});

service.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = `Basic c2FiZXI6c2FiZXJfc2VjcmV0`;
    if (getToken()) {
      config.headers["Blade-Auth"] = "bearer " + getToken();
    }
    if (getStore({ name: "language" })) {
      config.headers["Accept-Language"] =
        i18n.messages[getStore({ name: "language" })]["Accept-Language"];
    } else {
      config.headers["Accept-Language"] = "";
    }
    // 适配部分接口固定语种
    if (config.headers.language) {
      config.headers["Accept-Language"] = config.headers.language;
    }
    if (isOnly) {
      addPending(config);
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (isOnly) {
      deletePending(response);
    }
    const status = response.data.code || response.status;
    if (status === 401) {
      Message({
        message: response.data.msg,
        type: "error",
      });
    }
    if (status !== 200) {
      Message({
        message: response.data.msg,
        type: "error",
      });
      return Promise.reject(new Error(response.data.msg));
    }
    return response.data;
  },
  (error) => {
    if (isOnly) {
      deletePending(error);
    }
    Message({
      message: error.response.data.msg,
      type: "error",
    });
    return Promise.reject(new Error(error));
  }
);
const request = (config) => {
  if (config.isOnly) {
    isOnly = config.isOnly;
  } else {
    isOnly = false;
  }
  return service(config);
};

export default request;
